import { createSlice, createAsyncThunk, createAction, createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { COMMON_STATUS } from "../constants/status";
import { IItemInfo } from "../interface/IItem";
import { HeaderParamsModel } from "../model/common";
import ItemService from "../service/ItemService";
import { RootState } from "../store/store";

import { logoutUser } from "./common";


export const resetItem = createAction("itemDetail/reset")

const _service = new ItemService();


export const getItemDetailAsync = createAsyncThunk(
  "item/getItemDetail",
  async (params: HeaderParamsModel) => {
    const response = await _service.getItemDetail(params);
    return response;
  }
);


type SliceState = { value: IItemInfo[], status: string, }
const initialState = {
  value: [],
  status: COMMON_STATUS.INITIAL,
} as SliceState;

// const itemAdapter = createEntityAdapter({
//   selectId: (item:IItemInfo) => item.id,
// })



export const itemDetailSlice = createSlice({
  name: "itemDetail",
  // initialState: itemAdapter.getInitialState({
  //   status: COMMON_STATUS.INITIAL,
  // }),
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
    
      //For item detail
      .addCase(getItemDetailAsync.pending, (state: SliceState) => {
        state.status = COMMON_STATUS.LOADING;
      })
      .addCase(getItemDetailAsync.fulfilled, (state: SliceState, action) => {
   
        const found = state.value?.find(item => item.id === action.payload.id);
        if (found) {
          found.allergens = action.payload.allergens;
          found.mayContainAllergens = action.payload.mayContainAllergens;
          found.itemIngredients = action.payload.itemIngredients;
        }
        else{
          state.value.push(action.payload);
        }
        state.status = COMMON_STATUS.LOADED;
      })
      .addCase(getItemDetailAsync.rejected, (state: SliceState, action) => {
        state.status = COMMON_STATUS.FAILED;

      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetItem, (n) => {
        return initialState;
      })
  },
});

export const getItemDetails = (state: RootState) => state.itemDetail.value;

export default itemDetailSlice.reducer;